import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { clinicServices } from '@services/api'
import { StoreExt } from '@utils/reactExt'

export class clinicServicesStore extends StoreExt {
    @observable clinicService = {}
    @observable list = []

    @observable clinicServiceIds = []
    @observable loading = false
    @observable filters = {
        id: null,
        name: null,
        clinic_id: null,
        clinic_services_ids: [],
        service_clinic_related_type: null,
        serviceName: null
    }
    @observable paging = {
        page: 1,
        perPage: 1000,
        total: 0,
        lastPage: 0
    }
    @observable clinicServices = []
    @observable filtered = []
    @observable errors = { serverErrors: null }
    @action
    getClinicServices = async id => {
        this.loading = true
        let clinicServicesResult = (await clinicServices.getClinicServices({ ...id })).data

        runInAction(() => {
            this.clinicServices = clinicServicesResult.clinicServices
            this.filtered = clinicServicesResult.clinicServices
            this.loading = false
        })
    }
    @action
    getClinicServicesList = async page => {
        this.loading = true
        // let perPage = 1000
        const { list } = (await clinicServices.list({ page, perPage: this.paging.perPage })).data

        runInAction(() => {
            this.list = list
            this.filtered = list
            this.loading = false
        })
    }
    @action
    getFilteredClinicServicesList = () => {
        this.loading = true
        let list = this.list.slice(0)

        let filtered = list
        if (list && list.length > 0) {
            filtered = list.filter(clinicServiceItem => {
                if (this.filters.service_clinic_related_type == 'RELATED') {
                    if (this.filters.clinic_services_ids.includes(clinicServiceItem.id)) {
                        if (this.filters.serviceName && this.filters.serviceName.length > 0) {
                            if (clinicServiceItem.name.includes(this.filters.serviceName)) {
                                return clinicServiceItem
                            }
                        } else {
                            return clinicServiceItem
                        }
                    }
                }
                if (this.filters.service_clinic_related_type == 'NOT_RELATED') {
                    if (!this.filters.clinic_services_ids.includes(clinicServiceItem.id)) {
                        if (this.filters.serviceName && this.filters.serviceName.length > 0) {
                            if (clinicServiceItem.name.includes(this.filters.serviceName)) {
                                return clinicServiceItem
                            }
                        } else {
                            return clinicServiceItem
                        }
                    }
                }
                if (
                    this.filters.service_clinic_related_type == null ||
                    this.filters.service_clinic_related_type == 'ALL'
                ) {
                    if (this.filters.serviceName && this.filters.serviceName.length > 0) {
                        if (clinicServiceItem.name.includes(this.filters.serviceName)) {
                            return clinicServiceItem
                        }
                    } else {
                        return clinicServiceItem
                    }
                }
            })
        }
        runInAction(() => {
            this.filtered = filtered
            this.loading = false
        })
    }
    @action
    addServiceClinics = async (clinic_id, clinic_service_id) => {
        this.loading = true
        try {
            await clinicServices.addServiceClinics({ clinic_id, clinic_service_id })
        } catch (e) {
            runInAction(() => {
                if (e.response.status === 500) {
                    this.errors['serverErrors'] = 'הייתה בעיה בעידכון,נא נסה שנית.'
                } else if (e.response.status !== 200) {
                    this.errors['serverErrors'] = e.response.data
                }
            })
        }
        runInAction(() => {
            this.loading = false
        })
    }
    @action
    deleteServiceClinics = async (clinic_id, clinic_service_id) => {
        this.loading = true
        try {
            await clinicServices.deleteServiceClinics({ clinic_id, clinic_service_id })
        } catch (e) {
            runInAction(() => {
                if (e.response.status === 500) {
                    this.errors['serverErrors'] = 'הייתה בעיה בעידכון,נא נסה שנית.'
                } else if (e.response.status != 200) {
                    this.errors['serverErrors'] = e.response.data
                }
            })
        }
        runInAction(() => {
            this.loading = false
        })
    }
    @action
    updateAll = async () => {
        await this.getFilteredClinicServicesList()
        runInAction(() => {
            this.loading = false
        })
    }
    @action
    changePage = page => {
        this.loading = true
        const filters = { ...this.filters }

        runInAction(() => {
            this.paging.page = page
            this.filters = filters
        })
    }

    @action
    setFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (!value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = { ...newFilters }
        })
    }

    @action
    resetFilters = () => {
        this.filters = {
            id: null,
            name: null,
            clinic_id: null,
            clinic_services_ids: [],
            service_clinic_related_type: null,
            serviceName: null
        }
        this.errors = { serverErrors: null }
        this.getClinicServicesList(1)
    }
}

export default remotedev(new clinicServicesStore())
